import { render, staticRenderFns } from "./DiscBreadcrumbs.vue?vue&type=template&id=fc1736ca&scoped=true"
import script from "./DiscBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./DiscBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1736ca",
  null
  
)

export default component.exports